import { render, staticRenderFns } from "./CustomCampaignPage.vue?vue&type=template&id=79f3b494"
import script from "./CustomCampaignPage.vue?vue&type=script&lang=js"
export * from "./CustomCampaignPage.vue?vue&type=script&lang=js"
import style0 from "./CustomCampaignPage.vue?vue&type=style&index=0&id=79f3b494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports